import React from 'react'

import { Icon } from 'elements/media/Icon'
import { Text } from 'elements/text/Text'
import { Label, TLabelProps } from 'elements/ui/Label'

import { ICON } from 'config/icons'

import { COMMUNITY_DISPLAYMODE } from 'modules/community/constants'

import type { TCommunity } from '../types'

export type TCommunityFavoriteLabelProps = {
  community: TCommunity
} & TLabelProps

export const CommunityFavoriteLabel: TFCC<TCommunityFavoriteLabelProps> = ({ community, ...otherProps }) =>
  community.displayMode === COMMUNITY_DISPLAYMODE.FAVORITE ? (
    <Label colors="special" {...otherProps}>
      <Icon name={ICON.HEART} m="0 4px 0 0" size="15px" vAlign="unset" />
      <Text vAlign="unset" lineHeight="15px">
        trans:community:community.display-mode.favorite
      </Text>
    </Label>
  ) : null
